/* eslint-disable jsx-a11y/anchor-is-valid, class-methods-use-this, no-unneeded-ternary, react/no-find-dom-node */

import Grid from '@material-ui/core/Grid'
import { withStyles } from '@material-ui/core/styles'
import Visibility from '@material-ui/icons/Visibility'
import VisibilityOff from '@material-ui/icons/VisibilityOff'
import classNames from 'classnames'
import DOMPurify from 'dompurify'
import React from 'react'
import ReactDOM from 'react-dom'
import { Link } from 'react-router-dom'
import styled from 'styled-components'

import * as validations from '../../helpers/validations'
import theme from '../../utils/theme'
import ActionLink from '../ActionLink'
import AlertMessage from '../AlertMessage'
import { CornerHexagonBg } from '../Background/CornerHexagons'
import { PrimaryButton } from '../Button'
import ButtonWithLink from '../ButtonWithLink'
import GameDayPrivacy from '../GameDayPrivacy'
import InputField from '../InputField'
import Paper from '../Paper'
import STGTermsAndConditions from '../STGTermsAndConditions'

const styles = theme => ({
  pageWrapper: {
    padding: '60px 30px 0 30px',
    minHeight: 0,
    zIndex: 2,
    [theme.breakpoints.down(400)]: {
      padding: '30px 20px',
      background: '#fff !important',
    },
    '& main': {
      [theme.breakpoints.down(400)]: {
        width: '100% !important',
      },
    },
    '& .MuiPaper-root': {
      padding: 0,
      [theme.breakpoints.down(400)]: {
        width: '100% !important',
      },
    },
    '&.fixed': {
      position: 'relative',
      height: '100vh',
      overflow: 'auto',
    },
  },
  innerWrapper: {
    padding: '42px 34px',
    [theme.breakpoints.down(400)]: {
      padding: '30px 20px',
    },
  },
  form: {
    width: '100%', // Fix IE11 issue.
  },
  justifyCenter: {
    justifyContent: 'center',
    display: 'flex',
    alignItems: 'center',
  },
  logo: {
    margin: '0 auto 24px',
    maxWidth: 260,
    [theme.breakpoints.down(400)]: {
      margin: '0 auto 18px',
      maxWidth: 206,
    },
  },
  iconEndFix: {
    position: 'absolute',
    right: 0,
    bottom: 5,
  },
  FormSubHeading: {
    color: `var(--gameday-body-headingColor, ${theme.body.headingColor})`,
    textAlign: 'center',
  },
  title: {
    fontSize: theme.typography.fontSizeMedish,
    fontWeight: theme.typography.fontWeightBold,
    margin: '0 0 34px',
    color: theme.body.headingColor,
    '[data-theme="dark"] &': {
      color: theme.colors.darkModeOffWhite,
    },
    [theme.breakpoints.down(400)]: {
      fontSize: theme.typography.fontSizeSm,
      margin: '0 0 28px',
    },
  },
  navLink: {
    textAlign: 'center',
    margin: '32px 0',
    '& a': {
      textDecoration: 'none',
      color: theme.palette.primary.main,
      texAlign: 'center',
      fontWeight: theme.typography.fontWeightBolder,
      fontSize: theme.typography.fontSizeSm,
    },
  },
  textBox: {
    textAlign: 'center',
    padding: '1rem 0',
  },
  info: {
    color: theme.status.successColor,
  },
  error: {
    color: theme.status.errorColor,
  },
  success: {
    color: theme.status.successColor,
  },
  passwordField: {
    marginBottom: 4,
  },
  fullWidth: {
    width: '100%',
  },
  text: {
    fontSize: theme.typography.fontSizeSm,
    color: `var(--gameday-body-textColorAlt, ${theme.body.textColorAlt})`,
  },
  alert: {
    marginBottom: '38px',
    [theme.breakpoints.down(400)]: {
      marginBottom: 0,
    },
  },
  verificationError: {
    marginBottom: 10,
  },
})

const ResponsivePaper = styled(Paper)`

  [data-theme="dark"] & {
    background-color: ${theme.colors.darkModeLowBlack};
  }

  .panel-wrap {
    background-color: ${theme.body.backgroundAlt};
  }

  [data-theme="dark"] & .panel-wrap {
    background-color: ${theme.colors.darkModeLowBlack};
  }

  [data-theme="dark"] & .MuiInputBase-input {
    background-color: ${theme.colors.darkModeHighGrey} !important;
    color: ${theme.colors.darkModeOffWhite} !important;
  }

  [data-theme="dark"] & .MuiInputBase-adornedStart,
  [data-theme="dark"] & .MuiInputBase-adornedEnd {
    background-color: ${theme.colors.darkModeHighGrey} !important;
  }

  .left-panel .terms-block,
  .divider {
    display: none;
  }
  @media screen and (min-width: 728px) and (max-height: 800px) {
    display: flex;
    width: 100% !important;
    max-width: 800px;
    .panel-wrap {
      display: flex;
      width: 100%;
      flex-direction: row;
      padding: 0px;
      align-items: stretch;
    }
    .left-panel,
    .right-panel {
      width: 50%;
      padding: 34px;
      align-items: center;
    }
    .left-panel {
      display: flex;
      flex-direction: column;
      justify-content: center;
      .terms-block {
        display: block;
      }
      .terms,
      .break {
        display: none;
      }
    }
    .right-panel {
      .break,
      .terms-block {
        display: none;
      }
    }
    .logo-block {
      flex-grow: 3;
    }
    .logo {
      margin: 0 auto;
    }
    .divider {
      display: block;
      align-self: stretch;
      width: 1px;
      margin: 34px 0;
      background: ${theme.borders.borderColor};
    }
  }
  @media screen and (max-width: 460px) {
    margin-top: ${props => props.showAlert && '0px !important'};
  }
`

class LoginPage extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      fields: {
        email: {
          value: '',
          isError: false,
          errorMessage: 'Please enter email.',
        },
        password: {
          value: '',
          isError: false,
          errorMessage: 'Please enter Password.',
        },
      },
      showPassword: false,
    }
  }

  componentWillReceiveProps(nextProps) {
    const { emailErrorMessage, passwordErrorMessage } = nextProps
    if (emailErrorMessage || passwordErrorMessage) {
      const { fields } = this.state
      const newFields = { ...fields }
      const emailIsDifferent = emailErrorMessage !== fields.email.errorMessage
      const pwdIsDifferent = passwordErrorMessage !== fields.password.errorMessage
      if (emailErrorMessage && emailIsDifferent) {
        newFields.email.isError = true
        newFields.email.errorMessage = emailErrorMessage
      }
      if (passwordErrorMessage && pwdIsDifferent) {
        newFields.password.isError = true
        newFields.password.errorMessage = passwordErrorMessage
      }
      if (emailIsDifferent || pwdIsDifferent) {
        if ('scrollTo' in ReactDOM.findDOMNode(this.ref)) {
          ReactDOM.findDOMNode(this.ref).scrollTo(0, 0)
        }
      }
      this.setState(newFields)
    }
  }

  clearFields = () => {
    const { fields } = this.state
    fields.email.value = ''
    fields.email.isError = false
    fields.email.errorMessage = 'Please enter email.'
    fields.password.value = ''
    fields.password.isError = false
    fields.password.errorMessage = 'Please enter Password.'
    return fields
  }

  handleSubmit = e => {
    e.preventDefault()
    const { fields } = this.state
    const { handleSubmit } = this.props
    handleSubmit(fields)
  }

  handleResendVerificationEmail = e => {
    e.preventDefault()
    const { fields } = this.state
    const { handleResendVerificationEmail } = this.props
    handleResendVerificationEmail(fields)
  }

  onChange = (value, name) => {
    const { fields } = this.state
    const { onChange } = this.props
    let isErr = false
    let errMsg = ''
    const temp = { ...fields }
    temp[name].value = value

    if (name === 'email') {
      if (value.length === 0) {
        errMsg = validations.validateRequired(value, 'Email')
      } else {
        errMsg = validations.validateEmail(value)
      }
      if (errMsg) {
        isErr = true
      }
    }
    if (name === 'password') {
      errMsg = validations.validateRequired(value, 'Password')
      if (errMsg) {
        isErr = true
      }
    }
    temp[name].isError = isErr
    temp[name].errorMessage = errMsg
    this.setState({
      fields: temp,
    })
    onChange(value, name)
  }

  handleMouseDownPassword = event => {
    event.preventDefault()
  }

  handleClickShowPassword = () => {
    this.setState(state => ({
      showPassword: !state.showPassword,
    }))
  }

  onClickActionLink = () => {
    const { redirectForgotPasswordPath, history } = this.props
    history.push(redirectForgotPasswordPath)
  }

  renderSignUp = () => {
    const { classes, redirectSignUpPath, showSignUp } = this.props

    if (showSignUp) {
      return (
        <div className={classNames(classes.fullWidth)}>
          <div className={classNames(classes.navLink)}>
            {/* Redirect to Forgot Password page */}
            <span className={classNames(classes.text)}>No account yet? </span>
            <Link to={redirectSignUpPath} data-testid="signUpLink">
              Sign Up
            </Link>
          </div>
        </div>
      )
    }

    return null
  }

  render() {
    const {
      alertMessage,
      alertTitle,
      alertVariant,
      application,
      backgroundImage,
      classes,
      customWidth,
      formInfo,
      formSuccess,
      handleResendVerificationEmail,
      loadingLogin,
      logo,
      paymentProviders,
      reversed,
      showAlert,
      showGuestLogin,
      showTermsAndConditions,
      showGameDayPrivacy,
      showTrustPilot,
      /* eslint-disable-next-line no-unused-vars */
      // biome-ignore lint/correctness/noUnusedVariables: TODO
      termsLogo,
      title,
      redirectSignUpGuestPath,
      history,
      isFixed,
      icon,
      primaryColor,
      secondaryColor,
    } = this.props
    let { formError } = this.props
    const { fields, showPassword } = this.state
    const { email, password } = fields

    if (handleResendVerificationEmail && formError.includes('resend your verification email')) {
      formError = (
        <React.Fragment>
          <div className={classes.verificationError}>{formError}</div>
          <ActionLink label="Resend Verification Email" isStandalone onClick={this.handleResendVerificationEmail} />
        </React.Fragment>
      )
    }

    return (
      <>
        <ResponsivePaper
          application={application}
          width={customWidth}
          ref={_instance => {
            this.ref = _instance
          }}
          classes={{ root: classNames(classes.pageWrapper, isFixed && 'fixed') }}
          outsideContent={
            showAlert && (
              <AlertMessage title={alertTitle} className={classes.alert} variant={alertVariant} icon={icon} show>
                {/** biome-ignore lint/security/noDangerouslySetInnerHtml: TODO */}
                <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(alertMessage) }} />
              </AlertMessage>
            )
          }
          showAlert={showAlert}
        >
          <div className={classNames(classes.innerWrapper, 'panel-wrap')}>
            <div className="left-panel">
              <div className={classNames(classes.justifyCenter, 'logo-block')}>
                <img className={classNames(classes.logo, 'logo')} src={logo} alt="logo" />
              </div>
              {showTermsAndConditions && <STGTermsAndConditions className="terms-block" />}
            </div>
            <div className="divider" />
            <div className="right-panel">
              {formInfo.length > 0 ? <div className={classNames(classes.textBox, classes.info)}>{formInfo}</div> : ''}
              {formSuccess ? <div className={classNames(classes.textBox, classes.success)}>{formSuccess}</div> : ''}
              {formError ? <div className={classNames(classes.textBox, classes.error)}>{formError}</div> : ''}
              <div className={classNames(classes.FormSubHeading)}>
                <h2 className={classes.title}>{title}</h2>
              </div>
              <div>
                <form className={classes.form} onSubmit={this.handleSubmit}>
                  <Grid container>
                    <Grid item xs={12}>
                      <InputField
                        id="loginEmailField-input"
                        label="Email"
                        isRequired
                        errorText={email.isError ? email.errorMessage : ''}
                        value={email.value}
                        onChange={event => this.onChange(event.target.value, 'email')}
                        name="email"
                        dataTestId="loginEmailField"
                        withBorder
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <InputField
                        id="loginPasswordField-input"
                        className={classNames(classes.passwordField)}
                        label="Password"
                        isRequired
                        errorText={password.isError ? password.errorMessage : ''}
                        value={password.value}
                        onChange={event => this.onChange(event.target.value, 'password')}
                        type={showPassword ? 'text' : 'password'}
                        name="password"
                        withBorder
                        icon={showPassword ? <VisibilityOff /> : <Visibility />}
                        handleOnClickIcon={this.handleClickShowPassword}
                        showActionLink
                        actionLink="Forgot?"
                        actionLinkTestId="forgotPasswordLink"
                        dataTestId="loginPasswordField"
                        onClickActionLink={this.onClickActionLink}
                        aria-label={showPassword ? 'Show Password' : 'Hide Password'}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <PrimaryButton
                        fullWidth
                        disableRipple
                        type="submit"
                        disabled={
                          email.value.length === 0 || password.value.length === 0 || email.isError || password.isError
                        }
                        data-testid="loginButton"
                      >
                        {loadingLogin ? 'Processing...' : 'Login'}
                      </PrimaryButton>
                    </Grid>
                    {showGuestLogin && (
                      <Grid item xs={12}>
                        <ButtonWithLink
                          variant="outlined"
                          fullWidth
                          disableRipple
                          className={classNames(classes.submit)}
                          type="submit"
                          style={{ marginTop: '12px' }}
                          label="Continue as Guest"
                          onClick={() => history.push(redirectSignUpGuestPath)}
                          data-testid="guestButton"
                        />
                      </Grid>
                    )}
                  </Grid>
                </form>
              </div>
              {this.renderSignUp()}
              {showTermsAndConditions && <STGTermsAndConditions className="terms-block" />}
              {showGameDayPrivacy && <GameDayPrivacy showTrustPilot={showTrustPilot} />}
            </div>
          </div>
          {paymentProviders ? paymentProviders : null}
        </ResponsivePaper>
        {!backgroundImage && (
          <CornerHexagonBg useWindow primaryColor={primaryColor} secondaryColor={secondaryColor} reversed={reversed} />
        )}
      </>
    )
  }
}

LoginPage.defaultProps = {
  application: '',
  customWidth: 400,
  emailErrorMessage: '',
  formError: '',
  formInfo: '',
  formSuccess: '',
  onChange: () => {},
  passwordErrorMessage: '',
  reversed: false,
  showTrustPilot: true,
}

export default withStyles(styles)(LoginPage)
